import { render } from "./PlayerMaturityCard.vue?vue&type=template&id=5007883d&scoped=true"
import script from "./PlayerMaturityCard.vue?vue&type=script&lang=js"
export * from "./PlayerMaturityCard.vue?vue&type=script&lang=js"

import "./PlayerMaturityCard.vue?vue&type=style&index=0&id=5007883d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5007883d"]])

export default __exports__